module.exports = __webpack_public_path__ + "img/img7.1cb72ea3.jpg";